import { useUser } from 'common/CacheProvider';
import { __t } from 'common/i18n';
import { Button, Link, Text } from 'common/styles';
import Tooltip from '../Tooltip';
import { useEffect, useRef, useState } from 'react';
import theme from '../theme';

export default function SubscriptionButton() {
  const { hasSubscription, subscriptionRemainingDays } = useUser();
  const [openTooltip, setOpenTooltip] = useState(false);
  const [referenceElement, setReferenceElement] = useState<HTMLElement | null>(null);
  const subscriptionButtonMessage = (!hasSubscription || subscriptionRemainingDays <= 0) ? 'subscription.buy' : 'subscription.extend';

  const resizeTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const handleTooltip = () => {
    setOpenTooltip(Number(theme.breakpoints.md) > Number(window.innerWidth));
  };
  useEffect(() => {
    handleTooltip();
    window.addEventListener('resize', throttledHandle, { passive: true });
    return () => {
      window.removeEventListener('resize', throttledHandle);
      if (resizeTimerRef.current) {
        clearTimeout(resizeTimerRef.current);
        resizeTimerRef.current = null;
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const throttledHandle = () => {
    if (resizeTimerRef.current !== null) return;
    resizeTimerRef.current = setTimeout(() => {
      handleTooltip();
      resizeTimerRef.current = null;
    }, 100);
  };

  return (
    <Button
      ref={setReferenceElement}
      variant="primaryB"
      as={Link}
      href="/packages"
      inputSize="small"
      mx={{ xs: 2, md: 3 }}
    >
      <Tooltip
        disableMobileHover={openTooltip}
        anchor={referenceElement}
        placement="bottom"
        offsetY={10}
        type="denseSuccess"
        pInline='1rem'
        pBlock='0.3rem'
      >
        <Text variant="body3">
          {__t('common.discount.tooltip')}
        </Text>
      </Tooltip>
      {__t(subscriptionButtonMessage)}
    </Button>
  );
}
